import React, { useEffect, useState } from "react";
import InputField from "../../../component/input-field";
import SimpleBarReact from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";
import { useDispatch, useSelector } from "react-redux";
import Table from "../../../component/table";
import moment from "moment";
import { getTemplateValuesByOrderId } from "../../../redux/actions/salesOrder";

function BookingDetails({ embedded }) {
  const dispatch = useDispatch();
  const { performancedata } = useSelector((state) => state.todoPerformance);
  const [bookingdata, setbookingdata] = useState(performancedata.booking_template_id !== null ? performancedata.booking_data : performancedata.custom_fields)

  // let bookingdata =
  //   performancedata.booking_template_id !== null
  //     ? performancedata.booking_data
  //     : performancedata.custom_fields;
  const assetdata = performancedata.booking_assets;



  useEffect(() => {

    const inventory_order_id =  performancedata?.inventory_order_id ? performancedata.inventory_order_id : null;

    if(inventory_order_id){
      dispatch(
        getTemplateValuesByOrderId(inventory_order_id, (res) => {
          if (res.status === 1) {
            let controls = res.data.controls;

            controls = controls.map((item) => ({
              label: item.booking_template_custom_field.component.label,
              type: item.booking_template_custom_field.component.type,
              value: item.value,
            }));

            setbookingdata(controls)
          }
        })
      );
    }
  }, [performancedata]);

  return (
    <div
      className={`sm:py-2 ${
        embedded ? "overflow-y-scroll overflow-x-hidden" : ""
      } h-screen`}
      // className="sm:pl-5 sm:py-2 space-y-3 h-screen"
      style={{ maxHeight: "calc(100vh - 48px)" }}
    >
      <h4 className="text-sm font-bold leading-4 tracking-tight">
        Booking Details
      </h4>
      <SimpleBarReact>
        {/* style={{ maxHeight: "calc(100vh - 178px)" }} */}
        <div className="overflow-x-hidden">
          <div className="flex flex-wrap mb-6">
            {bookingdata?.length > 0 ? (
              bookingdata.map((ele) => {
                return (
                  <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                    <InputField
                      type="text"
                      label={ele.label}
                      placeholder={
                        ele.type === "date/time"
                          ? moment(ele.value).format("YYYY-MM-DD HH:mm")
                          : ele.value
                      }
                      wrapperClass="my-3"
                      disabled
                    />
                  </div>
                );
              })
            ) : (
              <p className="text-sm font-medium p-4">
                No booking details available.
              </p>
            )}
          </div>
        </div>
      </SimpleBarReact>
      <h4 className="text-sm font-bold leading-4 tracking-tight">
        Asset Details
      </h4>
      <div className="w-full p-3">
        <div className="border w-full bg-white rounded-md">
          <Table>
            <tr className="h-11">
              <th className="py-1">Asset Type</th>
              <th className="py-1">Asset Quantity</th>
              <th className="py-1">Remarks</th>
            </tr>
            {assetdata.map((item) => (
              <tr key={item.id} className="h-11">
                <td className="text-center text-gray-600">
                  {item.asset_type.asset_type}
                </td>
                <td className="text-center text-gray-600">{item.quantity}</td>
                <td title={item.remarks} className="text-center text-gray-600">
                  <div className="bmax-w-full truncate">{item.remarks}</div>
                </td>
              </tr>
            ))}
          </Table>
        </div>
      </div>
    </div>
  );
}

export default BookingDetails;
